import icons from '@/mixins/icons'
import { i18n } from '@/plugins/i18n'
export default {
    data() {
        return {
            triages: [
                'urgent',
                'immediate',
                'standard',
                'inconclusive',
                'none',
            ]
        }
    },
    mixins: [icons],
    methods: {
        riskAssessmentToken(name, severity) {
            if (severity === "risk_none") {
                severity = "none"
            }
            const patient = this.currentTrackPatient()
            if (patient) {
                const scopedToken = `assessment.${name}.${patient}.${severity}.title`
                if (this.assessmentTokenExists(scopedToken)) {
                    return scopedToken
                }
            }
            return `assessment.${name}.${severity}.title`
        },

        currentTrackPatient() {
            const classifications =
                (this.$store && this.$store.getters['v4/track/classifications']) || []
            const patient = classifications.find(c => c.name === 'patient')
            return patient ? patient.value : undefined
        },

        assessmentTokenExists(token) {
            if (!token) return false
            if (i18n.te(token, i18n.locale)) return true
            if (i18n.fallbackLocale && i18n.te(token, i18n.fallbackLocale)) return true
            return false
        },

        icon(severity) {
            const unknownSeverity = {
                color: 'possible',
                icon: this.icons.mdiCheckboxBlankOutline,
                darkTheme: false
            }

            const triageDisplay = {
                urgent: {
                    color: 'danger',
                    icon: this.icons.mdiAlertCircle,
                    darkTheme: true
                },
                immediate: {
                    color: 'warning',
                    icon: this.icons.mdiAlertCircle,
                    darkTheme: false
                },
                standard: {
                    color: 'caution',
                    icon: this.icons.mdiAlertCircle,
                    darkTheme: true
                },
                inconclusive: {
                    color: 'blue',
                    icon: this.icons.mdiHelpCircle,
                    darkTheme: true
                },
                none: {
                    color: 'success',
                    icon: this.icons.mdiCheckCircle,
                    darkTheme: true
                }
            }

            return triageDisplay[severity] || unknownSeverity
        },

        convertTreatmentToString(treatment) {
            const treatmentToken = `treatment.simple.${treatment.name}`
            const initialTranslation = this.$t(this.localizedToken(treatmentToken))
            const regexMatchDoubleBracketsGlobal = /\[\[(.*?)\]\]/g
            const result = initialTranslation.replace(regexMatchDoubleBracketsGlobal, (_, keyToReplace) => {
                const numberToReplace = treatment[keyToReplace]

                return this.$n(numberToReplace, 'decimal')
            })

            return result.replaceAll('\n', '<br>')
        },

        async recordsInQueue() {
            let records = 0
            try {
                if (window.indexedDB && 'serviceWorker' in navigator) {
                    let collectDatabaseName = 'workbox-background-sync'
                    let collectDatabase = await window.indexedDB.databases()

                    if (collectDatabase.find(x => x.name === collectDatabaseName)) {
                        let request = window.indexedDB.open(collectDatabaseName)
                        records = new Promise(function(resolve, reject) {
                            request.onsuccess = (event) => {
                                let db = request.result
                                let transaction = db.transaction(['requests'])
                                var objectStore = transaction.objectStore('requests')
                                var index = objectStore.index('queueName')
                                let count = index.getAllKeys('thinkmd-collect')
                                count.onsuccess = (event) => {
                                    resolve(count.result.length)
                                }
                                count.onerror = (event) => {
                                    reject(event)
                                }
                            }
                            request.onerror = (event) => {
                                reject(event)
                            }
                        })
                    }
                }
            }
            catch (e) {
                console.log(e)
                this.$sentry.withScope(scope => {
                    this.$sentry.captureException(e)
                });
            }
            this.$store.commit('setRecordsInQueue', await records)
            return records
        }
    }
}
